import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
  theme: {
    backgroundColor: BrandTokens.NeutralColorHighMedium,
    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelIntense),
    fontFamily: BrandTokens.FontFamily,
    fontWeight: BrandTokens.FontWeightMedium,
    lineHeight: GlobalTokens.LineHeightDefault,
    borderRadius: GlobalTokens.BorderRadiusCircular,

    motion: {
      transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
      transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
  },

    notification: {
      height: '8px',
      width: '8px',
      right: '2px',
      top: '2px',
      backgroundColor: BrandTokens.HighlightColorPure,
      border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.HighlightColorPure}`,
      borderRadius: GlobalTokens.BorderRadiusCircular
    },
    brand: {
      height: '24px',
      width: '24px'
    },
    sizes: {
      lg: {
        height: '124px',
        width: '124px',
        fontSize: GlobalTokens.FontSizeLg,
      },
      md: {
        height: '64px',
        width: '64px',
        fontSize: GlobalTokens.FontSizeXs
      },
      sm: {
        height: '40px',
        width: '40px',
        fontSize: GlobalTokens.FontSizeXxs
      }
    },
    states: {
      hover: {
        boxShadow: `0 0 0 ${GlobalTokens.BorderWidthThick} ${BrandTokens.BrandColorPrimaryLight}`
      }
    }
  }
}